import React from 'react';
import { scrollToBuy } from '../config';
import { ImageIcon } from 'lucide-react';
interface ImagePlaceholderProps {
  aspectRatio?: 'video' | 'square' | 'portrait';
  label?: string;
  className?: string;
}
export function ImagePlaceholder({
  aspectRatio = 'portrait',
  label = 'Reemplazar imagen',
  className = ''
}: ImagePlaceholderProps) {
  const aspectClasses = {
    video: 'aspect-video',
    square: 'aspect-square',
    portrait: 'aspect-[3/4]'
  };
  return <div onClick={scrollToBuy} className={`cursor-pointer w-full bg-gray-200 border-2 border-dashed border-gray-300 rounded-xl flex flex-col items-center justify-center text-gray-500 hover:bg-gray-100 hover:border-brand-teal transition-colors group ${aspectClasses[aspectRatio]} ${className}`} role="button" tabIndex={0} aria-label={`Imagen placeholder: ${label}. Clic para ir a comprar.`} onKeyDown={e => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      scrollToBuy();
    }
  }} data-id="element-246">
      <ImageIcon className="w-12 h-12 mb-3 text-gray-400 group-hover:text-brand-teal transition-colors" data-id="element-247" />
      <span className="font-medium text-sm text-center px-4 group-hover:text-brand-teal transition-colors" data-id="element-248">
        {label}
      </span>
      <span className="text-xs text-gray-400 mt-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-249">
        Clic para ir a la oferta
      </span>
    </div>;
}